<template>
<v-dialog
    v-model="dialog"
    max-width="1200"
>
    <v-card>
        <v-card-title>Note edit history</v-card-title>

        <v-card-text>
             <m-rc-crm-note
                v-for="(item, index) in results"
                :key="index"
                style="margin-bottom: 15px"
                :value="item"
                v-on:on-click-edit-note="onClickEditNote"
                v-on:on-click-view-edit-history="onClickViewEditHistory"
                history_mode
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            results: [],
        }
    },

    methods: {

        showDialog(note_id)
        {
            this.results = [];
            
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/red-chirp-crm/notes',
            
                {
                    'note_id': note_id,
                    'sort': 'time_note:desc'
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.results = data.results;
                    this.dialog = true;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get note edit history');
                },
            );

        },

        onOk()
        {
            this.dialog = false;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>